/* SectionDivider — kept as a render-nothing component so existing
   <SectionDivider /> usages don't break. The secondary nav bar is removed. */
export default function SectionDivider() {
  return null;
}
